import moment from 'moment';

/**
 *
 * Data to hash
 * Simple function to make unique hashes from data
 *
 * Simple method to make the hash from data
 * https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 *
 */

/**
 * Make the hash from the primitive value (string)
 *
 * @param str
 * @param hash
 * @returns {number}
 */
const strToHash = (str, hash = 0) => {
    let output = hash;

    const len = str.length;

    if (len === 0) {
        return output;
    }
    for (let i = 0; i < len; i += 1) {
        const char = str.charCodeAt(i);
        // eslint-disable-next-line no-bitwise
        output = ((output << 5) - output) + char;
        // eslint-disable-next-line no-bitwise
        output &= output;
    }
    return output;
};

/**
 * Hash function
 *
 * @param data
 * @param output
 * @returns {number}
 */
const makeHash = (data, output = 0) => {
    const isArray = Array.isArray(data);
    const isMoment = data instanceof moment;
    const isDate = data instanceof Date;

    const type = isArray ? 'array' : typeof data;

    output = strToHash(type, output);

    if (isArray) {
        // update hash by array value
        output = data
            .sort((a, b) => makeHash(a, 0) - makeHash(b, 0))
            .reduce((memo, value) => makeHash(value, memo), output);
    } else if (
        type === 'object'
        && data !== null
        && !isMoment
        && !isDate) {
        // update hash by object value
        Object.entries(data)
            .sort(([key1], [key2]) => strToHash(key1, 0) - strToHash(key2, 0))
            .forEach(([key, value]) => {
                output = strToHash(key, output);
                output = makeHash(value, output);
            });
    } else if (isMoment) {
        output = strToHash(String(data.unix()), output);
    } else if (isDate) {
        output = strToHash(String(data.getTime()), output);
    } else {
        output = strToHash(String(data), output);
    }

    return output;
};

export default function dataToHash(data) {
    return makeHash(data, 0).toString(16);
}
